import { GenericRadioChoiceStep } from '@eneco/flows/components';
import { FlowRoute, FlowRouteCategory, FlowActions } from '@eneco/flows/types';

import { AddressStep } from './steps/AddressStep';
import { ContactDetailsStep } from './steps/ContactDetailsStep';
import { PersonalDetailsStep } from './steps/PersonalDetailsStep';
import { HeatPumpLeadFlowContext } from './types/context';

export const initialContext: HeatPumpLeadFlowContext = {};

export const routes: FlowRoute<HeatPumpLeadFlowContext>[] = [
  {
    id: 'ADDRESS',
    path: '/adres/',
    category: FlowRouteCategory.JePostcode,
    component: AddressStep,
  },
  {
    id: 'HOME_OWNERSHIP',
    path: '/woningbezit/',
    category: FlowRouteCategory.JeWoning,
    component: GenericRadioChoiceStep,
  },
  {
    id: 'HOME_TYPE',
    path: '/type-woning/',
    category: FlowRouteCategory.JeWoning,
    component: GenericRadioChoiceStep,
  },
  {
    id: 'GAS_USAGE',
    path: '/gasverbruik/',
    category: FlowRouteCategory.JeVerbruik,
    component: GenericRadioChoiceStep,
  },
  {
    id: 'PERSONAL_DETAILS',
    path: '/je-gegevens/persoonlijke-gegevens/',
    category: FlowRouteCategory.JeGegevens,
    component: PersonalDetailsStep,
  },
  {
    id: 'CONTACT_DETAILS',
    path: '/je-gegevens/contactgegevens/',
    category: FlowRouteCategory.JeGegevens,
    component: ContactDetailsStep,
  },
];

export const actions: FlowActions<HeatPumpLeadFlowContext> = {};
